
import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";
import  BASE_URL  from "../../config/host";

export const allergySlice = createSlice({
    name: 'allergies',
    loading: false,
    initialState: {
        allergylist: [],
        allergyCount: 0
    },
    reducers:{
        listRequested: (state, action)=>{
            state.loading = true;
        },
        listRequestFailed: (state, action)=>{
            state.loading = false;
            state.allergylist ='';
            //console.log(action.payload);
        },
        listReceived: (state, action)=>{
            state.loading = false;
            state.allergylist = action.payload.data?action.payload.data:[];
            state.allergyCount = action.payload.count || 0
        }
    }
});


export const {listReceived,listRequested ,listRequestFailed } = allergySlice.actions;
//console.log(body);
export const fetchAllergies = (body)=> apiCallBegan({
    url: '/product_ingredients/list',
    method: 'post',
    data: body,
    baseUrl: BASE_URL,
    onSuccess: listReceived.type,
    onStart: listRequested.type,
    onError: listRequestFailed.type
 
});














